module.exports = __webpack_public_path__ + "static/media/sport-banner-greyhound.7a33a413.svg";